import { enqueueSnackbar, somethingWrongNotification } from '../redux/notifier/notifierActions';
import store from '../store';

const errorNotification = (error, errorLost = []) => {
  let processedError = false;

  errorLost.forEach(({ code, errorText, errorSubText }) => {
    if (error.response.status === code) {
      store.dispatch(
        enqueueSnackbar({
          message: errorText,
          options: {
            variant: 'error',
            subMessage: errorSubText,
          },
        }),
      );
      processedError = true;
    }
  });

  if (!processedError) {
    store.dispatch(somethingWrongNotification());
  }
};

export default errorNotification;
